import { h, Fragment } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import ChevronIcon from 'utils/icon/icon-chevron.svg';

const ProductDetailsTray = ({addOpenDetailsEl, ...props }) => {
  const [currentVariant, setCurrentVariant] = 
    useState(props.product.variants.find(
    (v) =>
      JSON.stringify(v.selectedOptions) ===
      JSON.stringify(props.product.variantBySelectedOptions.selectedOptions),
  ));

  const detailsTriggerEl = useRef(null);
  const dimensionsTriggerEl = useRef(null);
  const shippingTriggerEl = useRef(null);
  useEffect(() => {
    addOpenDetailsEl(detailsTriggerEl);
  }, [detailsTriggerEl]);
  useEffect(() => {
    addOpenDetailsEl(dimensionsTriggerEl);
  }, [dimensionsTriggerEl]);
  useEffect(() => {
    addOpenDetailsEl(shippingTriggerEl);
  }, [shippingTriggerEl]);

  const handleCurrentVariantUpdated = (e) => {
    const { currentProductData } = e.detail;
    setCurrentVariant(currentProductData.variants.find(
      (v) =>
        JSON.stringify(v.id) ===
        JSON.stringify(e.detail.currentVariant),
    ));
  };

  const scrollToReviews = () => {
    const reviewsSectionMainWidget =  document.querySelector('#yotpo-app');
    if (reviewsSectionMainWidget) 
      reviewsSectionMainWidget.scrollIntoView({
        behavior: 'smooth'
      });
  };

  const setSelectedTab = (e) => {
    const buttonTarget = (e.target.tagName === 'BUTTON') ? e.target : e.target.parentNode;
    const { tray } = buttonTarget.dataset;
    document.dispatchEvent(
      new CustomEvent('expand-tray', {
        detail: {
          tray,
        },
      }),
    );
  };
  

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => document.removeEventListener('currentVariantUpdated', handleCurrentVariantUpdated);
  }, []);
  
  return (
    <div>
      <button 
        className='w-full border-b border-grey-3 uppercase py-5 flex items-center justify-between utility-1' 
        data-tray='details' 
        ref={detailsTriggerEl}
        onClick={setSelectedTab}>
        <span>{ props.detailsTrayDetailsTitle }</span>
        <ChevronIcon/>
      </button>
      <button 
        className='w-full border-b border-grey-3 uppercase py-5 flex items-center justify-between utility-1' 
        data-tray='dimensions' 
        ref={dimensionsTriggerEl}
        onClick={setSelectedTab}>
        <span>{ props.detailsTrayDimensionsTitle }</span>
        <ChevronIcon/>
      </button>
      <button 
        className='w-full border-b border-grey-3 uppercase py-5 flex items-center justify-between utility-1' 
        data-tray='shipping' 
        ref={shippingTriggerEl}
        onClick={setSelectedTab}>
        <span>{ props.detailsTrayShippingTitle }</span>
        <ChevronIcon/>
      </button>

      {currentVariant?.detailsTray?.reviews && (
        <>
          { props?.detailsTrayReviewsTitle && (
            <button 
              className='w-full border-b border-grey-3 uppercase py-5 flex items-center justify-between utility-1'
              onClick={scrollToReviews}>
              <span>{ props.detailsTrayReviewsTitle }</span>
              <ChevronIcon className='rotate-90' />
            </button>
          )}
          <div 
            className='py-8 border-b border-grey-3' 
            data-target='details-reviews-content' 
            dangerouslySetInnerHTML={{__html: 
              currentVariant.detailsTray.reviews}} />
        </>
      )}
    </div>
  );
};

export default ProductDetailsTray;
